<template>
  <div v-if="product && productPrice">
    <define-favorites-cta>
      <vf-button
        v-if="!isDigitalProduct
          && (selectedVariant?.notifyMe && $feature.showNotifyMeOnPDP && isSelectedProductOutOfStock
            ? (!favoriteCta.hideWhenNotifyMe && $feature.catalogFavorites)
            : $feature.catalogFavorites)
        "
        :aria-label="isFavorite ? $t.removeFromFavorites : $t.favorites"
        class="h-8 w-8 b-0 p-0"
        :data-test-id="`pdp-${isFavorite ? 'remove' : 'add'}-favorites-cta`"
        :disabled="favorites.error"
        :loading="isFavoritePending"
        :size="ctaSize"
        :variant="isFavorite ? favoriteCta.variantSelected : 'transparent'"
        @click="toggleFavorites(productColor?.label)"
      >
        <vf-icon
          :class="{ 'c-brand-3': isFavorite }"
          :name="isFavorite ? 'heart-filled' : 'heart'"
          :size="favoriteCta.iconSize"
        />
        <span v-if="!favoriteCta.iconOnly" class="ml-2">{{ $t.favorites }}</span>
      </vf-button>
    </define-favorites-cta>

    <div class="flex gap-4 between">
      <product-eyebrow v-if="!$feature.showBadgeAboveTitle" />
      <pdp-section-breadcrumbs class="ml-a" />
    </div>
    <div class="relative mt-1 flex between">
      <div>
        <h1 class="body-2" data-test-id="product-name">
          {{ product.name }}
        </h1>
        <transition name="slide">
          <p
            v-if="$feature.showShortDescriptionOnPDP && product.shortDescription"
            class="body-4 c-grey-30"
            :class="{ '<lg:hidden': !isDrawerExpanded }"
            style="margin-top: 0.125rem"
          >
            {{ product.shortDescription }}
          </p>
        </transition>
        <product-eyebrow v-if="$feature.showBadgeAboveTitle" style="margin-top: 0.125rem" />
      </div>
      <favorites-cta class="-mr-1 -mt-1 <lg:hidden" />
    </div>

    <div class="mt-1 flex items-center between space-x-1">
      <product-pricing
        class="body-3"
        :currency="product.currency"
        :is-digital-product="isDigitalProduct"
        :price="productPrice"
        :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
        show-dynamic-pricing-on-plp
        :show-omnibus-details="isDrawerExpanded"
        :show-original-price-for-omnibus="$feature.showOmnibusBadgeOnQuickshopAndPDP"
        show-sale-price-tooltip
      />
      <favorites-cta class="-mr-1 -mt-2 lg:hidden" />
    </div>
    <div
      ref="promotionRef"
      class="body-4 space-y-2"
      :class="{ 'mt-2': !!promotionDivHeight, '<lg:hidden': !isDrawerExpanded }"
    >
      <p v-if="product.promoExclusionsMessage">
        {{ product.promoExclusionsMessage }}
      </p>
      <div id="below-price-info" />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  isDrawerExpanded?: boolean
}>()

const { details: { favoriteCta, ctaSize } } = useAppConfig().pages.pdp
const favorites = useFavoritesStore()
const { $feature, $t } = useNuxtApp()
const {
  isDigitalProduct,
  product,
  productPrice,
  selectedVariant,
  isFavorite,
  isFavoritePending,
  isSelectedProductOutOfStock,
  toggleFavorites,
  productColor
} = usePdp()

const promotionRef = ref()
const { height: promotionDivHeight } = useElementBounding(promotionRef)

const [DefineFavoritesCta, FavoritesCta] = createReusableTemplate()
</script>
